import React, {Component} from 'react';
import CategoriesList from "./CategoriesList";

class Quote extends Component {
/*  state = {
    isOpen: false
  }*/

  render() {
    const {quote} = this.props
    const quoteId = this.props.quote.id
    console.log(quoteId);
    return (
        <div className="card">
          <blockquote className="card-body blockquote pb-1">
            <section className="card-text">
              {quote.text}
            </section>
            <footer className="blockquote-footer text-right mt-2">
              <span className="quote-source">
                {quote.author}
                &nbsp;
                {quote.title !== "" ? <span>«{quote.title}»</span> : <span></span>}
              </span>
              <div>
                <CategoriesList quote = {quote.category} id = {quoteId}/>
              </div>
            </footer>
          </blockquote>
        </div>
    )
  }

/*  handleClick = () => {
    // console.log('clicked');
    this.setState({
      isOpen: !this.state.isOpen
    })
  }*/
}

export default Quote


// WEBPACK FOOTER //
// ./src/components/Quote.js